import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'owl.carousel/dist/assets/owl.carousel.min.css';
import 'owl.carousel/dist/assets/owl.theme.default.min.css';

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { 
  faLocationArrow,
  faMapMarkerAlt,
  faPhoneAlt,
  faFax,
  faEnvelope,
  faStar,
  faAtom,
  faFolder,
  faCaretRight,
  faArrowLeft
} from '@fortawesome/free-solid-svg-icons'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

library.add(
  faLocationArrow,
  faMapMarkerAlt,
  faPhoneAlt,
  faFax,
  faEnvelope,
  faStar,
  faAtom,
  faFolder,
  faCaretRight,
  faArrowLeft
)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
//jQuery
import $ from 'jquery'
window.$ = $
window.jQuery = $

//Owl Carousel
let owl_carousel = require('owl.carousel');
window.fn = owl_carousel;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
